module.exports = __webpack_public_path__ + "img/ferencvaros-logo-icon.28cef1c9.png";